/* eslint-disable @atlaskit/design-system/use-tokens-typography, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-exported-css -- Disabled to upgrade atlaskit/theme */
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import { css } from 'styled-components';
import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const small = css`
    /* stylelint-disable scale-unlimited/declaration-strict-value */
    font-size: 12px;
`;

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const regular = css`
    font-size: 14px;
`;

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const medium = css`
    font-size: 16px;
`;

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const mediumLarge = css`
    font-size: 18px;
`;

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const xsmall = css`
    font-size: 11px;
`;

export const h800 = css({
    color: token('color.text', '#172B4D'),
    fontWeight: token('font.weight.semibold', '600'),
    letterSpacing: '-0.01em',
    marginTop: token('space.500', '40px'),
    fontSize: '2.071em',
    fontStyle: 'inherit',
    lineHeight: 1.103,
});

export const h700 = css({
    color: token('color.text', '#172B4D'),
    fontWeight: token('font.weight.medium', '500'),
    letterSpacing: '-0.01em',
    marginTop: token('space.500', '40px'),
    fontSize: '1.714em',
    fontStyle: 'inherit',
    lineHeight: 1.167,
});

export const h600 = css({
    color: token('color.text', '#172B4D'),
    fontWeight: token('font.weight.medium', '500'),
    letterSpacing: '-0.008em',
    //eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/design-system/use-tokens-space
    marginTop: '28px',
    fontSize: '1.429em',
    fontStyle: 'inherit',
    lineHeight: 1.2,
});

export const h500 = css({
    color: token('color.text', '#172B4D'),
    fontWeight: token('font.weight.semibold', '600'),
    letterSpacing: '-0.006em',
    marginTop: token('space.300', '24px'),
    fontSize: '1.143em',
    fontStyle: 'inherit',
    lineHeight: 1.25,
});

export const h400 = css({
    color: token('color.text', '#172B4D'),
    fontWeight: token('font.weight.semibold', '600'),
    letterSpacing: '-0.003em',
    marginTop: token('space.200', '16px'),
    fontSize: '1em',
    fontStyle: 'inherit',
    lineHeight: 1.143,
});

export const h300 = css({
    color: token('color.text', '#172B4D'),
    fontWeight: token('font.weight.semibold', '600'),
    marginTop: token('space.250', '20px'),
    fontSize: '0.857em',
    fontStyle: 'inherit',
    lineHeight: 1.333,
    textTransform: 'uppercase',
});

export const h200 = css({
    color: token('color.text.subtlest', '#6B778C'),
    fontWeight: token('font.weight.semibold', '600'),
    marginTop: token('space.200', '16px'),
    fontSize: '0.857em',
    fontStyle: 'inherit',
    lineHeight: 1.333,
});

export const h100 = css({
    color: token('color.text.subtlest', '#6B778C'),
    fontWeight: token('font.weight.bold', '700'),
    marginTop: token('space.200', '16px'),
    fontSize: '0.786em',
    fontStyle: 'inherit',
    lineHeight: 1.455,
});
